import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumb({ items = [] }) {
  if (items.length === 0) return null;
  return (
    <nav aria-label="Fil d'Ariane" className="bg-[#F4F6F8] border-b border-[#062133]/5" data-testid="breadcrumb">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-1.5 text-xs sm:text-sm text-[#062133]/50 overflow-x-auto whitespace-nowrap">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <span key={i} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight size={12} className="shrink-0 opacity-40" />}
              {isLast ? (
                <span className="text-[#062133]/80 font-medium">{item.name}</span>
              ) : (
                <Link to={item.url || "/"} className="hover:text-[#336DBF] transition-colors">{item.name}</Link>
              )}
            </span>
          );
        })}
      </div>
    </nav>
  );
}
